import { render, staticRenderFns } from "./lsCollFromCenterForm.vue?vue&type=template&id=7ff12073&scoped=true&"
import script from "./lsCollFromCenterForm.vue?vue&type=script&lang=js&"
export * from "./lsCollFromCenterForm.vue?vue&type=script&lang=js&"
import style0 from "./lsCollFromCenterForm.vue?vue&type=style&index=0&id=7ff12073&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff12073",
  null
  
)

export default component.exports